<template>
    <div>
        <div v-if="menu != ''" v-html="menu"></div>

        <div id="consentBox" class="grt-cookie grt-cookie-active">
            <div class="grt-cookies-msg">
                <p>
                    We use cookies to ensure that we give you the best experience on our website. If you continue to use this site, 
                    you acknowledge that you accept and understand our <a href="https://walottery.com/Privacy/">Privacy Policy.</a>
                </p>
            </div>
            <span class="grt-cookie-button" @click="acceptBtn()">Accept</span>
        </div>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
            currentTime: new Date().getFullYear(),
            menu: '',
        }
    },
    mounted: function () {
        this.getMenu();

        let cookieValue = ('; '+document.cookie).split(`; GDRP_Terms_Accepted=`).pop().split(';')[0];
        const consentBox = document.getElementById("consentBox"); 

        cookieValue !== 'true' ? consentBox.classList.remove("hide") : 
            consentBox.classList.add("hide");

    },
    methods: {
        acceptBtn(){
            document.cookie = "GDRP_Terms_Accepted=true"
            if (document.cookie) { 
                consentBox.classList.add("hide"); 
            } else { 
                console.log 
                    ("Cookie can't be set! Please"+ 
                    " unblock this site from the cookie"+ 
                    " setting of your browser."); 
            } 
        },
        getToken() {
            // then hit API with token
            this.getAPItoken()
                .then((token) => {
                    this.fetchData(token);
                });
        },
        getMenu() {
            let menuData = JSON.parse(sessionStorage.getItem('mt_footerMenu'));

            if (menuData !== undefined && menuData !== "" && menuData !== null) {
                this.showMenu(menuData);
                
                setTimeout(() => {
                    let selector = document.querySelector("#copy-year");
                    if (selector !== null) {
                        selector.innerHTML = this.currentTime;
                    }
                }, 500);

            } else {
                this.getToken();
            }
        },
        showMenu(data) {
            let parser = new DOMParser();
            let htmlDoc = parser.parseFromString(data, 'text/html');

            this.menu = htmlDoc.body.innerHTML;
        },
        fetchData(apiToken) {
            return fetch(process.env.VUE_APP_APIPROTOCOL + process.env.VUE_APP_APIURL + '/1.0/Games/StaticContentElements/StaticContentElement/GetContentElementByKey?contentKey=footercontent', {
                headers: {
                    'Authorization': 'Bearer ' + apiToken
                }
            })
                .then(response => response.json())
                .then(json => {
                    let element = json.data[0].centralContent;

                    sessionStorage.setItem('mt_footerMenu', JSON.stringify(element));
                    this.showMenu(element)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    .hide { 
        opacity: 0; 
        pointer-events: none; 
        transition: all 0.3s ease; 
    }

    .grt-cookie {
        display: none;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 20px;
        background: #474747;
        color: #474747;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        z-index: 9999;
        opacity: 90%;
    }

    .grt-cookie-active {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: row;
    }

    .grt-cookie p {
        font-size: 14px;
        margin: 0;
        padding: 0;
        line-height: 1.35;
        color: #FFFFFF;
        font-weight: lighter;
    }

	.grt-cookie p a {
		color: #81ff20;
		text-decoration: underline;
		font-size: 14px;
		font-weight: lighter;
		margin: 0;
		padding: 0;
	}

    /*.grt-cookie-button {
        display: inline-block;
        cursor: pointer;
        font-weight: normal;
        font-size: 16px;
        padding: 3px 18px;
        margin-left: 12px;
        background: #6ec829;
        color: #fff;
        text-transform: capitalize;
        white-space: nowrap;
    }*/

    .grt-cookie-button {
        width: auto;
        line-height: 110%;
        padding: 10px 15px;
        font-size: 12px;
        font-family: ITC Avant Garde Gothic W01 Bd, Avant Garde, Avantgarde, Century Gothic, CenturyGothic, AppleGothic, sans-serif;
        color: #fff;
        background-color: #046208;
        text-align: center;
        text-transform: uppercase;
        font-weight: bold;
        display: inline-block;
        cursor: pointer;
        -webkit-tap-highlight-color: #4ba84f;
        transition: all .2s ease-in-out 0s;
    }

	@media (max-width:767px) {
		.grt-cookie {
			flex-direction: column;
			padding: 15px;
		}

			.grt-cookie p, .grt-cookie p a {
				font-size: 13px;
			}

		.grt-cookie-button {
			font-size: 13px;
			padding: 3px 14px;
			margin: 8px 0 0 0;
		}
	}
</style>